<script>
import ViewTitle from '@/components/ViewTitle'
import WideIconTile from '@/components/WideIconTile'
import StoreLoyaltyCardFrame from '@/frames/storeLoyaltyCardFrame'

export default
{
    name: 'loyalty-card-edit',

    created ()
    {
        StoreLoyaltyCardFrame.initFrame(this.$store, this.$store.state.user.ownedStore.id, true)
    },

    render () 
    {
        return (
            <div id='loyalty-card-edit-view'>
                <view-title>Carte de fidélité</view-title>
                <wide-icon-tile class='tile' on-click={() => this.onTileClicked('scan')} title='Créditer une carte' icon={require('@/assets/img/qr-code.svg')}
                    inline-svg={true} />
                <wide-icon-tile class='tile' on-click={() => this.onTileClicked('rewards')} title='Éditer les récompenses' icon={require('@/assets/img/giftbox.svg')} />
                <wide-icon-tile class='tile' on-click={() => this.onTileClicked('history')} title='Historique des transactions' icon={require('@/assets/img/history.svg')}
                    inline-svg={true} />
                <wide-icon-tile class='tile' on-click={() => this.onTileClicked('customers')} title='Mes clients' icon={require('@/assets/img/people.svg')} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onTileClicked (route)
        {
            this.$router.push({ path: route, append: true })
        }
    },

    components:
    {
        ViewTitle,
        WideIconTile
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-edit-view
{
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .tile
    {
        .icon
        {
            fill: var(--theme-text-color);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEdit.vue